import { ImportError } from './ImportError'

/**
 * Error that is thrown when the fit test does not have a related person.
 */
export class ImportRelatedError extends ImportError {
  constructor(message: string) {
    super(message)
    this.name = 'ImportRelatedError'
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
